<template>
  <div>
    <div v-if="loading" class="dw-loading">
      <b-spinner small></b-spinner> Loading...
    </div>
    <div v-else-if="!typeCounts.length" class="dw-empty">No alerts sent yet this period.</div>
    <template v-else>
      <div class="dw-stat-grid">
        <div class="dw-stat-tile">
          <div class="dw-stat-tile-label">Total</div>
          <div class="dw-stat-tile-value">{{ totalCount }}</div>
        </div>
        <div v-for="[type, count] in typeCounts" :key="type" class="dw-stat-tile">
          <div class="dw-stat-tile-label">{{ alertTypeLabel(type) }}</div>
          <div class="dw-stat-tile-value">{{ count }}</div>
        </div>
      </div>
      <div v-if="truncated" class="dw-truncation-note">
        Counts reflect the {{ resultsLimit.toLocaleString() }} most recent alerts in this range.
      </div>
    </template>
  </div>
</template>

<script>
import { alertTypeCounts, alertTypeLabel } from '../../utils/alerts_analytics'

export default {
  name: 'widget_alerts_summary',
  props: {
    // shared across every alert-detail widget by main_dashboard.vue's
    // load_alerts_detail(), so this widget costs no API call of its own.
    alerts: { type: Array, default: () => [] },
    loading: { type: Boolean, default: false },
    // true when the API capped the shared alert fetch at its newest-first
    // results_limit -- counts then only cover that slice.
    truncated: { type: Boolean, default: false },
    resultsLimit: { type: Number, default: 0 },
  },
  computed: {
    // exact per-alert_type breakdown, not the coarser late_alert_cnt/
    // trip_notification_cnt buckets the tenant-dashboard rollup provides
    // (those bundle several distinct alert_type values together).
    typeCounts() {
      return alertTypeCounts(this.alerts)
    },
    totalCount() {
      return this.alerts.length
    },
  },
  methods: {
    alertTypeLabel,
  },
}
</script>
